<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">La Dulceria de Caroya - {{ today | date:'y'}} © Copyright</p>
    </div>
  </div>
</div>